// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1R4N5","error":"Textarea_error__3OLs0","readonly":"Textarea_readonly__2Q_4d","disabled":"Textarea_disabled__2GRcL"};